import React from 'react'
import { Card, Space } from 'antd'
import type { CardProps } from 'antd'

import './PaginatedListTable.css'

interface PaginatedListToolbarProps
    extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
    align?: 'left' | 'right'
}

interface PaginatedListContainerProps
    extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

const joinClassNames = (...classNames: Array<string | undefined>) =>
    classNames.filter(Boolean).join(' ')

export const PaginatedListContainer: React.FC<PaginatedListContainerProps> = ({
    children,
    className,
    ...restProps
}) => (
    <div
        className={joinClassNames('paginated-list-container', className)}
        {...restProps}
    >
        {children}
    </div>
)

export const PaginatedListToolbar: React.FC<PaginatedListToolbarProps> = ({
    align = 'right',
    children,
    className,
    ...restProps
}) => (
    <div
        className={joinClassNames(
            'paginated-list-toolbar',
            `paginated-list-toolbar-${align}`,
            className
        )}
        {...restProps}
    >
        <Space wrap>{children}</Space>
    </div>
)

export const PaginatedListCard: React.FC<CardProps> = ({
    children,
    className,
    classNames,
    ...restProps
}) => (
    <Card
        {...restProps}
        className={['paginated-list-card', className]
            .filter(Boolean)
            .join(' ')}
        classNames={{
            ...classNames,
            body: joinClassNames('paginated-list-card-body', classNames?.body),
        }}
    >
        {children}
    </Card>
)

export default PaginatedListCard
